import * as d3 from 'd3'

export default {
  
  methods: {

    set_LocalValues(){

      this.rawData = JSON.parse(JSON.stringify(this.DataItems))
      
      let cutoff = JSON.parse(JSON.stringify(this.Queries.SQL1[0].CUTOFF))
      let json = JSON.parse(JSON.stringify(this.JQueries))

      this.header = json.header
      this.table    = json.table
      this.gantt    = json.gantt
      this.legends  = json.legends
      this.columns  = json.columns
      this.keys     = json.keys

      // Timeline
      this.timeline = {...json.timeline,
        cutoff: cutoff,
        week: [],
        month: [],
        year: [],
        scale: null,
      }
      this.gmx_TimelineValues(this.timeline)

      // Legends
      this.legends.forEach(d=> {
        d.count = this.rawData.filter(f=> f.STATUS == d. code).length
      })


      // Columns
      let x = 10
      this.columns.forEach(d=> {
        d.sx = x
        d.mx = x + d.width/2
        if(d.align == 'start') d.x = x + this.table.padding
        if(d.align == 'middle') d.x = x + d.width/2 
        if(d.align == 'end') d.x = x + d.width - this.table.padding
        x = x + d.width
      })
      this.table.width = x
      this.header.width = x
      this.timeline.x = this.header.x + this.table.width

    
      // raw data
      this.rawData.forEach(d=> {
        if(d.DESCR.length > 50) d.DESCR = d.DESCR.substr(0,30) + '..'
        if(d.VENDOR.length > 40) d.VENDOR = d.VENDOR.substr(0,30) + '..'
        if(d.EARLY > d.LATE) {
          let tmp = d.EARLY
          d.EARLY = d.LATE
          d.LATE = tmp
        }
        d.eta = this.timeline.scale(new Date(d.ETA))
        d.early = this.timeline.scale(new Date(d.EARLY))
        d.late = this.timeline.scale(new Date(d.LATE))
      })

      // Set CANVAS HEIGHT
      let height = this.table.y + (this.rawData.length * this.table.lineHeight) + 30
      if(height < 1000) this.Canvas.CanvasHeight = 1000
      else this.Canvas.CanvasHeight = height
    },
  }
}